// extracted by mini-css-extract-plugin
export default {"footerBg":"ia-z","footerTopLinks":"ja-z","footerFeedback":"ka-z","footerSocial":"la-z","footerLegalLinks":"ma-z","footerIconCards":"na-z","footerBotCopy":"oa-z"};